export default __webpack_public_path__ + "static/media/134.bde7f493.jpg";